<script setup lang="ts">
import { StoryblokComponent } from '@storyblok/vue'
import type { StoryblokAsset } from '../../types'

// TODO: Apply Hero4Draft around a specific word in the title

interface Props {
  blok: {
    logo?: StoryblokAsset
    title: string
    title_word_to_mark?: string
    description?: string
    actions?: any[]
    image: StoryblokAsset
    badger?: any[]
    title_word_mark_image?: StoryblokAsset
  }
}
defineProps<Props>()

const highlightWords = (text: string, word: string, image: string) => {
  const regex = new RegExp(`\\b(${word})\\b`, 'gi')
  return text.replace(regex, `<span class="hero-4-title-highlight">$1<img src='${image}'></span>`)
}
</script>

<template>
  <div v-editable="blok" p="x-2 lg:x-[100px] y-10 lg:y-20" overflow-hidden>
    <div p-px rounded="28px md:40px" max-w="768px lg:1080px" mx-auto relative :class="$style.outerContainer">
      <img
        :src="blok.image.filename"
        :alt="blok.image.alt"
        flex-1 w-full h-full max-h="40vh lg:800px"
        rounded="t-28px md:t-40px"
        object-center object-cover
        class="lg:hidden"
      >

      <div v-if="blok.badger?.length" class="!absolute top-[-12px] right-[-12px] md:top-[-30px] md:right-[-30px]">
        <div v-for="badger in blok.badger" :key="badger._uid">
          <StoryblokComponent :blok="badger" />
        </div>
      </div>

      <div grid="~ lg:cols-2" overflow-hidden :class="$style.container" class="rounded-b-28px lg:rounded-40px">
        <div min-w="60%" p="6 lg:x-[80px] lg:y-[60px]" col items-start justify="lg:between" gap="32px">
          <img v-if="blok.logo" :src="blok.logo.filename" :alt="blok.logo.alt" w="140px lg:194px">

          <div col class="gap-[12px] lg:w-[420px]">
            <div
              class="font-circular-bold font-bold text-[31.99px] lg:text-[60px] leading-[35.189px] lg:leading-[60px] tracking-[-1.28px] lg:tracking-[-2.4px]"
              v-html="(blok.title_word_to_mark && blok.title_word_mark_image ? highlightWords(blok.title, blok.title_word_to_mark, blok.title_word_mark_image.filename) : blok.title)"
            />

            <div class="text-circular-bold text-[16px] leading-[28px] tracking-[-0.32px]">
              {{ blok.description }}
            </div>
          </div>

          <div v-if="blok.actions?.length" center flex-wrap>
            <StoryblokComponent v-for="action in blok.actions" :key="action._uid" :blok="action" />
          </div>
        </div>

        <img
          :src="blok.image.filename"
          :alt="blok.image.alt"
          flex-1 w-full h-full max-h="40vh lg:800px"
          rounded="lg:r-40px"
          object-center object-cover
          class="hidden lg:block"
        >
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.hero-4-title-highlight {
  position: relative;
  display: inline-block;
}

.hero-4-title-highlight img {
  content: "";
  display: block;
  max-width: 120%;
  max-height: 120%;
  z-index: 0;
  position: absolute;
  top: 0;
  left: 0;
  user-select: none;
}
</style>

<style module lang="scss">
.outerContainer {
  background: rgb(169,147,255);
  background: linear-gradient(30deg, rgba(169,147,255,0.5) 0%, rgba(253,147,231,0.5) 49%, rgba(255,136,236,0.5) 85%);
  padding: 1px;
  box-shadow: 0px 0px 40px 0px #0000000A;
}

.container {
  background: white;
}
</style>
